import i18n from 'app/i18n';

export const SPORT_VOKRUG_PLUS_PROMO_TRANSLATION_NAMESPACE = 'sportVokrugPlusPromo';

const translations = {
  en: {
    ariaLabel: 'Learn about the Sport Vokrug+ subscription',
    benefitCategories: 'Copy categories from previous events.',
    benefitFutureFeatures: 'Access upcoming tools for event organizers.',
    benefitNews: 'Publish news in the sport’s “News” section.',
    button: 'Sport Vokrug+',
    choosePlan: 'Choose a plan',
    description: 'Spend less time on setup and more time organizing competitions.',
    eyebrow: 'Subscription for organizers',
    footerNote: 'You can manage your subscription in profile settings.',
    title: 'Set up events faster',
  },
  ru: {
    ariaLabel: 'Узнать о подписке Спорт вокруг+',
    benefitCategories: 'Копируйте категории из прошлых мероприятий.',
    benefitFutureFeatures: 'Получайте доступ к новым будущим функциям для организаторов.',
    benefitNews: 'Публикуйте новости в разделе «Новости» вида спорта.',
    button: 'Спорт вокруг+',
    choosePlan: 'Выбрать план',
    description: 'Меньше повторяющихся настроек — больше времени на организацию соревнований.',
    eyebrow: 'Подписка для организаторов',
    footerNote: 'Управлять подпиской можно в настройках профиля.',
    title: 'Готовьте мероприятия быстрее',
  },
  uz: {
    ariaLabel: 'Sport Vokrug+ obunasi haqida bilib oling',
    benefitCategories: 'O\'tgan tadbirlardan kategoriyalarni nusxalang.',
    benefitFutureFeatures: 'Tashkilotchilar uchun kelajakdagi yangi funksiyalardan foydalaning.',
    benefitNews: 'Sportning “Yangiliklar” bo‘limida yangiliklarni joylashtiring.',
    button: 'Sport Vokrug+',
    choosePlan: 'Tarifni tanlang',
    description: 'Kamroq takroriy sozlamalar — musobaqalarni tashkil etish uchun ko\'proq vaqt.',
    eyebrow: 'Tashkilotchilar uchun obuna',
    footerNote: 'Obunani profil sozlamalarida boshqarishingiz mumkin.',
    title: 'Tadbirlarni tezroq tayyorlang',
  },
};

Object.entries(translations).forEach(([language, resources]) => {
  i18n.addResourceBundle(
    language,
    SPORT_VOKRUG_PLUS_PROMO_TRANSLATION_NAMESPACE,
    resources,
    true,
    false,
  );
});
